/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-param-reassign */
import React from 'react';
import 'signer-app/parts/progress/index.module.css';

type Props = React.PropsWithChildren<{
  progress: number;
  loop: boolean;
  onTweenedProgress?: (progress: number) => void;
  className?: string;
}>;

type State = {
  progress: number;
};

class Progress extends React.Component<Props, State> {
  private _tweener: any;

  state = {
    progress: 0,
  };

  /**
   */

  shouldComponentUpdate(nextProps: Props) {
    if (nextProps.progress === this.props.progress) return true;
    if (this._tweener) this._tweener.stop();
    this.tweenProgress(nextProps.progress);
    return true;
  }

  /**
   */

  componentDidMount() {
    this.tweenProgress(this.props.progress);
  }

  onEnd = () => {
    if (this.props.loop) {
      this.setState({ progress: 0 }, () =>
        this.tweenProgress(this.props.progress),
      );
    }
  };

  /**
   */

  tweenProgress = (progress: number) => {
    this._tweener = tween(
      this.state.progress,
      progress,
      1000 * 3,
      easeInOutQuad,
      this.setProgress,
      this.onEnd,
    );
  };

  /**
   */

  componentWillUnmount() {
    if (this._tweener) this._tweener.stop();
  }

  /**
   */

  setProgress = (progress: number) => {
    this.setState({
      progress,
    });

    if (this.props.onTweenedProgress) {
      this.props.onTweenedProgress(progress);
    }
  };

  /**
   */

  render() {
    const sigSegments = 2180;
    const circSegments = 25;
    const progress = this.state.progress;
    const sigThreshold = 0.98;
    const sigProgress = progress < sigThreshold ? progress / sigThreshold : 1;
    const circProgress = progress > 0.63 ? 1 : 0;

    const classNames = `${
      this.props.className ? `${this.props.className} ` : ''
    }m-common-progress`;

    const sigStyle = {
      strokeDasharray: `${sigSegments}px`,
      strokeDashoffset: `${
        sigSegments - Math.round(sigProgress * sigSegments)
      }px`,
    };

    const circleStyle = {
      strokeDasharray: `${circSegments}px`,
      strokeDashoffset: `${
        circSegments - Math.round(circProgress * circSegments)
      }px`,
    };

    return (
      <div className={classNames}>
        <svg viewBox="0 0 468 245" version="1.1">
          <g id="loading" transform="translate(1.000000, -2.000000)">
            <g className="x-_____" transform="translate(0.000000, 122.000000)">
              <path d="M0,26 L482.5,26" id="Line" stroke="#CFCFCF"></path>
              <g
                id="Line-Copy-+-Line-Copy-2"
                transform="translate(2.000000, 0.000000)"
                stroke="#C7C7C7"
              >
                <path
                  d="M1.59787239,1.59787239 L20.232667,20.232667"
                  id="Line-Copy"
                  transform="translate(10.500000, 10.500000) scale(-1, 1) translate(-10.500000, -10.500000) "
                ></path>
                <path
                  d="M1.5978724,1.5978724 L20.232667,20.232667"
                  id="Line-Copy-2"
                ></path>
              </g>
            </g>
            <g id="progress" transform="translate(43.000000, 0.000000)"></g>
            <g
              id="bg-+-Shape-+-Shape-Copy"
              transform="translate(43.000000, 4.000000)"
            >
              <path
                className="signature-fill-background"
                d="M0.128093823,139 C12.4280938,139.3 30.8280938,128.4 38.8280938,120.3 C48.2280938,110.9 56.4280938,100.4 63.5280938,89.2 C78.1280938,66 90.8280938,37.3 89.3280938,9.3 C89.1280938,5.4 88.5280938,1.3 83.9280938,0.6 C78.2280938,-0.3 75.1280938,5.4 72.8280938,9.5 C65.8280938,21.6 61.2280938,34.9 57.5280938,48.3 C53.4280938,62.8 49.9280938,77.5 48.8280938,92.5 C47.8280938,105.6 47.9280938,121.6 53.9280938,133.6 C56.1280938,138.1 60.5280938,142 65.7280938,142.4 C70.2280938,142.8 74.7280938,140.1 78.2280938,137.4 C89.9280938,128.3 90.4294625,108.465236 95.1294625,95.3652364 C93.3294625,95.1652364 89.3280938,121.3 93.8280938,131.5 C96.0008102,136.592304 100.755157,140.485994 106.056566,141.428209 C108.563129,141.873699 111.191987,141.659386 113.728094,140.6 C130.728094,133.5 136.028094,103.5 122.828094,91 C116.628094,85.1 107.328094,84.5 100.228094,89.2 C96.8280938,91.5 93.4280938,95.5 94.5280938,99.8 C96.5280938,107.9 107.028094,109.5 113.828094,109.3 C122.428094,109 131.87153,107.31628 139.310119,103.836916 C144.351135,101.479006 149.691662,94.0000021 153.891662,91.0000021 C158.991662,87.4000021 167.250353,86.5000021 172.050353,92.5000021 C174.450353,95.5000021 175.328094,97 173.928094,93.9 C173.798584,93.628029 173.651882,93.3657024 173.489562,93.1129659 C173.244521,92.549342 172.955127,92.3794445 172.878437,92.2889385 C170.273428,89.2146481 165.219603,87.8276587 161.428094,88 C155.828094,88.3 151.257678,92.9928732 148.057678,97.1928732 C140.757678,106.592873 136.128094,122.4 140.728094,133.9 C142.628094,138.6 146.928094,141.8 151.928094,142.3 C157.528094,142.9 162.028094,139.7 165.228094,135.3 C173.428094,123.9 175.128094,107.2 174.128094,93.6 C173.511531,93.6924844 173.269372,96.6265862 173.498915,100.928604 C174.013959,110.581428 176.903827,127.121153 183.267638,133.899996 C189.890101,141.002347 198.112499,130.312403 198.305569,130.002688 C198.305569,130.002688 201.165011,124.561901 201.345364,124.204348 C201.461067,123.974964 204.454581,116.519651 205.339332,112.212315 C205.65602,110.670549 205.915983,109.083011 206.103909,107.475588 C206.398365,104.956958 208.128088,98.9667482 210.795315,94.3747579 C212.749414,91.0105136 215.717196,88.3889374 215.761868,88.3544943 C222.028049,83.5230267 230.580543,82.3131651 236.482815,86.9570333 C239.575623,89.3904343 241.337542,93.8501066 242.960592,99.3359375 C244.098776,102.1 241.098776,89.6 235.498776,86.1 C229.498776,82.4 221.898776,83.9 216.498776,87.9 C210.498776,92.4 207.698776,99.6 206.298776,106.7 C204.798776,114.4 203.698776,123.3 207.698776,130.5 C210.798776,136.2 216.798776,140.2 223.398776,139.1 C230.798776,138 236.198776,131.8 239.298776,125.4 C246.750437,109.937803 252.790125,8.1 251.298776,8.1 C249.643859,28.64855 245.51646,69.832817 243.637832,95.6532495 C242.792028,107.278227 242.402054,115.788931 242.898776,117.9 C244.198776,123.4 246.098776,129.9 249.798776,134.4 C252.498776,137.6 256.698776,139.8 260.898776,138.5 C265.098776,137.2 267.498776,132.5 269.398776,128.8 C272.018428,123.727023 273.352815,117.975291 274.68032,112.500003 C276.545331,104.807775 280.31735,90.2028438 279.712546,89.5000038 C279.237583,90.0914489 279.146872,90.2256632 279.05177,90.3737235 C278.007051,92.1050002 274.727646,98.1712148 273.028332,106.384035 C270.999718,116.18837 270.720693,128.462917 272.298776,132 C274.798776,137.5 280.498776,140 286.198776,137.9 C290.598776,136.3 293.998776,132.3 296.298776,128.3 C299.698776,122.2 301.698776,115.5 303.798776,108.8 C304.898776,105.2 306.098776,101.7 307.798776,98.4 C308.898776,96.3 310.898776,91.6 313.498776,91.1 C316.498776,90.6 313.058019,106.376662 312.458019,110.576662 C311.358019,118.476662 306.719865,144.253558 309.158703,137.800005 C311.163382,132.495307 320.042351,109.183412 322.357922,104.697268 C324.990107,99.5977209 329.307986,93.7028017 332.562512,91.9941427 C335.13188,90.6451981 336.922839,92.8385111 337.498791,93.6342794 C338.544744,95.0794277 338.698776,97.93278 338.698776,98.6 C338.598776,102 338.098776,105.3 337.498776,108.7 C336.098776,116.4 331.098776,136.7 343.398776,138.7 C355.798776,140.8 361.698776,122.7 364.898776,114.2 C364.898776,114.2 369.710449,98.5102539 376.145519,91.1000005 C382.58059,83.6897472 386.616688,84.1616267 390.1875,84.1616211 C393.758312,84.1616155 397.827637,84.751564 403.183117,91.9941427 C397.610936,82.2090819 385.1,81.9 377.7,89.4 C369.2,98 363,114.5 367.3,126.3 C369,131 372.4,136.2 377.4,137.8 C382.8,139.5 387.9,136.3 391.7,132.7 C402.3,122.3 404.325191,107.686914 403.799998,93.6342772 C405.019387,106.59388 407.966975,147.856795 407.3,169.2 C406.9,180.3 405.9,191.3 403.8,202.2 C402.3,210 400.8,219 396.2,225.6 C392.4,231 385.9,234.4 379.4,231.7 C371.5,228.3 372.2,215.8 372.8,208.9 C376.1,171.7 393.5,130.1 428.9,113.3"
                id="Shape"
              ></path>
              <path
                className="signature-fill-background"
                d="M283.032216,78.1 C282.365979,78.1 281.578608,77.6760309 281.154639,77.2520619 C280.670103,76.7675258 280.791237,75.6773196 280.791237,74.8899485 C280.791237,73.3757732 282.305412,72.164433 283.57732,72.164433 C284.304124,72.164433 285.212629,72.7701031 285.636598,73.4363402 C285.878866,73.9208763 286,74.8293814 286,75.4350515 C286,77.7365979 283.698454,78.1 283.032216,78.1 Z"
                id="Shape-Copy"
              ></path>

              <path
                style={sigStyle}
                className="signature-fill"
                d="M0.128093823,139 C12.4280938,139.3 30.8280938,128.4 38.8280938,120.3 C48.2280938,110.9 56.4280938,100.4 63.5280938,89.2 C78.1280938,66 90.8280938,37.3 89.3280938,9.3 C89.1280938,5.4 88.5280938,1.3 83.9280938,0.6 C78.2280938,-0.3 75.1280938,5.4 72.8280938,9.5 C65.8280938,21.6 61.2280938,34.9 57.5280938,48.3 C53.4280938,62.8 49.9280938,77.5 48.8280938,92.5 C47.8280938,105.6 47.9280938,121.6 53.9280938,133.6 C56.1280938,138.1 60.5280938,142 65.7280938,142.4 C70.2280938,142.8 74.7280938,140.1 78.2280938,137.4 C89.9280938,128.3 90.4294625,108.465236 95.1294625,95.3652364 C93.3294625,95.1652364 89.3280938,121.3 93.8280938,131.5 C96.0008102,136.592304 100.755157,140.485994 106.056566,141.428209 C108.563129,141.873699 111.191987,141.659386 113.728094,140.6 C130.728094,133.5 136.028094,103.5 122.828094,91 C116.628094,85.1 107.328094,84.5 100.228094,89.2 C96.8280938,91.5 93.4280938,95.5 94.5280938,99.8 C96.5280938,107.9 107.028094,109.5 113.828094,109.3 C122.428094,109 131.87153,107.31628 139.310119,103.836916 C144.351135,101.479006 149.691662,94.0000021 153.891662,91.0000021 C158.991662,87.4000021 167.250353,86.5000021 172.050353,92.5000021 C174.450353,95.5000021 175.328094,97 173.928094,93.9 C173.798584,93.628029 173.651882,93.3657024 173.489562,93.1129659 C173.244521,92.549342 172.955127,92.3794445 172.878437,92.2889385 C170.273428,89.2146481 165.219603,87.8276587 161.428094,88 C155.828094,88.3 151.257678,92.9928732 148.057678,97.1928732 C140.757678,106.592873 136.128094,122.4 140.728094,133.9 C142.628094,138.6 146.928094,141.8 151.928094,142.3 C157.528094,142.9 162.028094,139.7 165.228094,135.3 C173.428094,123.9 175.128094,107.2 174.128094,93.6 C173.511531,93.6924844 173.269372,96.6265862 173.498915,100.928604 C174.013959,110.581428 176.903827,127.121153 183.267638,133.899996 C189.890101,141.002347 198.112499,130.312403 198.305569,130.002688 C198.305569,130.002688 201.165011,124.561901 201.345364,124.204348 C201.461067,123.974964 204.454581,116.519651 205.339332,112.212315 C205.65602,110.670549 205.915983,109.083011 206.103909,107.475588 C206.398365,104.956958 208.128088,98.9667482 210.795315,94.3747579 C212.749414,91.0105136 215.717196,88.3889374 215.761868,88.3544943 C222.028049,83.5230267 230.580543,82.3131651 236.482815,86.9570333 C239.575623,89.3904343 241.337542,93.8501066 242.960592,99.3359375 C244.098776,102.1 241.098776,89.6 235.498776,86.1 C229.498776,82.4 221.898776,83.9 216.498776,87.9 C210.498776,92.4 207.698776,99.6 206.298776,106.7 C204.798776,114.4 203.698776,123.3 207.698776,130.5 C210.798776,136.2 216.798776,140.2 223.398776,139.1 C230.798776,138 236.198776,131.8 239.298776,125.4 C246.750437,109.937803 252.790125,8.1 251.298776,8.1 C249.643859,28.64855 245.51646,69.832817 243.637832,95.6532495 C242.792028,107.278227 242.402054,115.788931 242.898776,117.9 C244.198776,123.4 246.098776,129.9 249.798776,134.4 C252.498776,137.6 256.698776,139.8 260.898776,138.5 C265.098776,137.2 267.498776,132.5 269.398776,128.8 C272.018428,123.727023 273.352815,117.975291 274.68032,112.500003 C276.545331,104.807775 280.31735,90.2028438 279.712546,89.5000038 C279.237583,90.0914489 279.146872,90.2256632 279.05177,90.3737235 C278.007051,92.1050002 274.727646,98.1712148 273.028332,106.384035 C270.999718,116.18837 270.720693,128.462917 272.298776,132 C274.798776,137.5 280.498776,140 286.198776,137.9 C290.598776,136.3 293.998776,132.3 296.298776,128.3 C299.698776,122.2 301.698776,115.5 303.798776,108.8 C304.898776,105.2 306.098776,101.7 307.798776,98.4 C308.898776,96.3 310.898776,91.6 313.498776,91.1 C316.498776,90.6 313.058019,106.376662 312.458019,110.576662 C311.358019,118.476662 306.719865,144.253558 309.158703,137.800005 C311.163382,132.495307 320.042351,109.183412 322.357922,104.697268 C324.990107,99.5977209 329.307986,93.7028017 332.562512,91.9941427 C335.13188,90.6451981 336.922839,92.8385111 337.498791,93.6342794 C338.544744,95.0794277 338.698776,97.93278 338.698776,98.6 C338.598776,102 338.098776,105.3 337.498776,108.7 C336.098776,116.4 331.098776,136.7 343.398776,138.7 C355.798776,140.8 361.698776,122.7 364.898776,114.2 C364.898776,114.2 369.710449,98.5102539 376.145519,91.1000005 C382.58059,83.6897472 386.616688,84.1616267 390.1875,84.1616211 C393.758312,84.1616155 397.827637,84.751564 403.183117,91.9941427 C397.610936,82.2090819 385.1,81.9 377.7,89.4 C369.2,98 363,114.5 367.3,126.3 C369,131 372.4,136.2 377.4,137.8 C382.8,139.5 387.9,136.3 391.7,132.7 C402.3,122.3 404.325191,107.686914 403.799998,93.6342772 C405.019387,106.59388 407.966975,147.856795 407.3,169.2 C406.9,180.3 405.9,191.3 403.8,202.2 C402.3,210 400.8,219 396.2,225.6 C392.4,231 385.9,234.4 379.4,231.7 C371.5,228.3 372.2,215.8 372.8,208.9 C376.1,171.7 393.5,130.1 428.9,113.3"
                id="Shape"
              ></path>
              <path
                style={circleStyle}
                className="signature-fill"
                d="M283.032216,78.1 C282.365979,78.1 281.578608,77.6760309 281.154639,77.2520619 C280.670103,76.7675258 280.791237,75.6773196 280.791237,74.8899485 C280.791237,73.3757732 282.305412,72.164433 283.57732,72.164433 C284.304124,72.164433 285.212629,72.7701031 285.636598,73.4363402 C285.878866,73.9208763 286,74.8293814 286,75.4350515 C286,77.7365979 283.698454,78.1 283.032216,78.1 Z"
                id="Shape-Copy"
              ></path>
            </g>
          </g>
        </svg>
        {this.props.children ? (
          <span className="message">{this.props.children}</span>
        ) : undefined}
      </div>
    );
  }
}

export default Progress;

/**
 */

function tween(
  from: number,
  to: number,
  duration: number,
  ease: {
    (t: any, b: any, c: any, d: any): any;
    (arg0: number, arg1: any, arg2: number, arg3: any): any;
  },
  each: { (progress: any): void; (arg0: any): void },
  end: { (): void; (): void },
) {
  if (!end) end = function endFunc() {};
  const fps = 30;
  const ms = 1000 / fps;
  let currentTime = 0;
  const timer = setInterval(() => {
    const difference = to - from;
    currentTime = Math.min(currentTime + ms, duration);
    // var progress     = currentTime / duration;
    // var currentValue = from + difference * progress;

    each(ease(currentTime, from, difference, duration));
    if (currentTime >= duration) {
      stop();
      end();
    }
  }, ms);

  function stop() {
    clearInterval(timer);
  }

  return {
    stop,
  };
}

/**
 */

// function easeNone(t, b, c, d) {
//   return b + c * (t/d);
// }

/**
 * from http://gizma.com/easing/
 */

function easeInOutQuad(t: number, b: number, c: number, d: number) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
}
